import type { IProps as IBlockWrapperProps } from '@/layouts/BlockWrapper/BlockWrapper.interface';
import type { BlockEntry } from '@/types/blocks';

export interface ITabItem {
  /** A unique value for the tab. */
  value: string;
  /** The label displayed on the tab trigger. */
  label: string;
  /** An array of block configurations to render as content for this tab. */
  items: BlockEntry[];
}

export interface IProps extends IBlockWrapperProps {
  /** An array of tab items to display. */
  tabs: ITabItem[];
  /** The value of the tab that should be active when initially rendered. */
  defaultValue?: string;
  /** The orientation of the tabs. */
  orientation?: 'horizontal' | 'vertical';
  /** When `automatic`, tabs are activated when receiving focus. When `manual`, tabs are activated when clicked. */
  activationMode?: 'automatic' | 'manual';
  /** When true, keyboard navigation will loop from last tab to first, and vice versa. */
  loop?: boolean;
  /** Additional class names to apply to the block. */
  className?: string;
}

export const VIDEO_COMPONENTS = [
  'FeatureVideoWidget',
  'Video',
  'FiftyFiftyVideoBlock',
];
